/*
 * Jira Ticket:
 * Created Date: Mon, 1st Jun 2020, 16:57:12 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import { Filter, ReferenceInput, SelectInput, TextInput } from 'react-admin';
import { adStatusOptions } from 'utils/choices';

const AdvertFilter = props => {
  return (
    <Filter {...props}>
      <TextInput
        source="name"
        label={'resources.Advert.fields.adName'}
        options={{ resettable: true }}
      />
      <TextInput
        label={'resources.Advert.fields.advertiserName'}
        source="advertiserName"
        options={{ resettable: true }}
      />
      <ReferenceInput
        label={'resources.Advert.fields.region'}
        source="regionId"
        reference="Region"
        perPage={1000}
        sort={{ field: 'name', order: 'ASC' }}
        allowEmpty={true}
      >
        <SelectInput source="id" optionText="name" />
      </ReferenceInput>
      <SelectInput
        source="status"
        choices={adStatusOptions}
        label={'resources.Advert.fields.status'}
      />
    </Filter>
  );
};

export default AdvertFilter;
